import React, { useEffect } from "react";
import { RestlessTable } from "../../../_metronic/layout/components/Table";
import { useDispatch, useSelector } from "react-redux";
import * as imageAuthActions from "../../../redux/actions/imageAuth";
import RestlessImageFormatter from "../../../_metronic/layout/components/Table/RestlessImageFormatter";
import RestlessDateFormatter from "../../../_metronic/layout/components/Table/RestlessDateFormatter";
import * as actions from "../../../redux/actions/media";
import { Route } from "react-router-dom";
import IdentityVerificationDialog from "../RestlessUsers/RestlessIdentityVerificationDialog/IdentityVerificationDialog";

export default function RestlessMediaPage({ history }) {
  const dispatch = useDispatch();

  const { imageToken, mediaList, listLoading } = useSelector((state) => ({
    imageToken: state.imageAuth.imageToken,
    mediaList: state.media.mediaList,
    listLoading: state.media.listLoading,
  }));

  useEffect(() => {
    dispatch(imageAuthActions.fetchImageToken());
    dispatch(actions.fetchMedia());
  }, [dispatch]);

  const mediaUIEvents = {
    openDetailMediaDialog: (row) => {
      history.push({
        pathname: `/media/${row.id}`,
        state: { row: row },
      });
    },
  };

  const columns = [
    {
      dataField: "related[0].__contentType",
      text: "Source",
      sort: true,
    },
    {
      dataField: "related[0].id",
      text: "ID",
      sort: true,
    },
    {
      dataField: "created_at",
      text: "Created",
      sort: true,
      formatter: RestlessDateFormatter,
    },
    {
      dataField: "ext",
      text: "Type",
      sort: true,
      formatter: (cellContent, row) => {
        return <div>{row.ext === ".mp4" ? "VIDEO" : "IMAGEN"}</div>;
      },
    },
    {
      dataField: "formats",
      text: "Content",
      formatter: RestlessImageFormatter,
      formatExtraData: {
        profileToken: imageToken,
        openImageDialog: (imgURL) => {
          return mediaUIEvents.openDetailMediaDialog(imgURL);
        },
      },
    },
  ];
  return (
    <>
      {listLoading ? (
        <div className="d-flex justify-content-center align-content-center">
          <span className="mx-3 spinner spinner-primary"></span>
        </div>
      ) : (
        <div>
          <Route path="/media/:id">
            {({ history, match }) => (
              <IdentityVerificationDialog
                show={match != null}
                id={match && match.params.id}
                row={history.location.state?.row}
                verificationToken={imageToken}
                onHide={() => {
                  history.push("/media");
                }}
              />
            )}
          </Route>
          <RestlessTable data={mediaList} columns={columns} withPagination />
        </div>
      )}
    </>
  );
}
